// extracted by mini-css-extract-plugin
export default {"avatarImage":"HeaderAvatarMenuItem-module__avatarImage__QB4SE"};